module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/High_Stakes2#Contents-A"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("The March half-moon played hide-and-seek behind a screen of huge clouds that scudded across the midnight sky. After moving silently up the concrete walkway to the Large Animal Barn at Croft College, she bent down a few feet behind the dark blue campus police car and peered through its rear window. A young officer was in the driver’s seat, hat tilted over his eyes and his earplugs in as he dozed to the low volume country western song twanging out of his iPad mini.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("At the back entrance to the long, white barn she crouched at the door, quickly used her tension wrench and steel pick on the simple lock, and slid inside the long, dimly lit, one-story wooden building. The corridor ran between stalls housing a couple of Black Angus heifers and a Holstein cow. She softly walked forward. Her masked face momentarily split in a smile as she inhaled the familiar smell of hay and horse.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("The lock had been easier")]), _vm._v(" "), _c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("to pick than Secretariat in a Fantasy League Race. That was a relief, she thought, as she brushed a trickle of sweat from her forehead, took a deep breath. No noise from the wide metal door either opening or closing, very little from the dark bay mare looking out from her stall at the north end of the barn. So far, so good. The inquisitive mare twitched her ears in a tentative greeting")]), _vm._v(" "), _c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("as the dark-clad figure slowly approached. She watched the visitor with luminous brown eyes above her long face with its large crooked white star. Her racetrack days, when regular attention was paid her by attentive humans, were long behind her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("As her soft muzzle was being stroked, the mare heard a gentle voice saying, “You’ve been probed, prodded, perhaps bred to a lesser representative of your species. You are not an object of well-earned affection, but of experimentation. No more, babe, no more.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("The needle sank deep into the broad bay neck delivering the large dose of phenobarbital. The mare twisted her head away but quickly stopped as the drug took effect. With a shudder, she collapsed on the stall’s floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("The woman put the needle and syringe into her right jacket pocket. From the left one, she took out a printed card and quickly entered the stall. She placed the white placard on the dead horse’s neck. In large dark letters, it read:")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Center"
  }, [_vm._v("NO MORE EXPLOITATION OF"), _c('br'), _vm._v("THIS ONE OF GOD’S CREATURES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic char-style-override-1"
  }, [_vm._v("It was the second time she had left such a message. After a final pat on the mare’s neck, the woman exited the stall and moved rapidly, silently, to the south barn door and slipped out into the dark night. The heifers and the Holstein swiveled their heads to watch her go.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f76c4ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/High_Stakes-6.vue
// module id = 78
// module chunks = 0